import React from 'react';

type UseDelayedVisibilityResult = {
  isVisible: boolean;
  showImmediately: () => void;
};

export function useDelayedVisibility(
  targetVisibility: boolean,
  delayMs: number,
): UseDelayedVisibilityResult {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (!targetVisibility) {
      setIsVisible(false);
      return undefined;
    }

    setIsVisible(false);

    const timeoutId = window.setTimeout(() => {
      setIsVisible(true);
    }, delayMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [delayMs, targetVisibility]);

  const showImmediately = React.useCallback(() => {
    setIsVisible(targetVisibility);
  }, [targetVisibility]);

  return {
    isVisible,
    showImmediately,
  };
}
